module.exports = "/assets/newsletter/bg_mobile.png?4unLiFI";